module.exports = __webpack_public_path__ + "img/Master-5.7393e82c.gif";